// @ts-check
import BlockCard from '../BlockCard';

const LEVEL = {
  out: { label: 'Out', cls: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300' },
  low: { label: 'Low', cls: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300' },
};

/** Out-of-stock and low-stock counts with a compact list of the worst variants. */
export default function InventoryBlock({ block }) {
  const { low_stock: low = 0, out_of_stock: out = 0, items = [] } = block.data || {};

  return (
    <BlockCard title="Inventory" href={block.href} headline={block.headline}>
      <div className="flex gap-6 text-sm">
        <p data-testid="inventory-out-count">
          Out <span className="ml-1 font-semibold text-red-600 dark:text-red-400">{out}</span>
        </p>
        <p data-testid="inventory-low-count">
          Low <span className="ml-1 font-semibold text-amber-600 dark:text-amber-400">{low}</span>
        </p>
      </div>
      {items.length === 0 ? (
        <p className="mt-3 text-sm text-muted-foreground">Stock levels look healthy</p>
      ) : (
        <ul className="mt-3 space-y-1 text-sm">
          {items.map((i, idx) => (
            <li key={`${i.name}-${i.sku_or_variant}-${idx}`} data-testid="inventory-item" className="flex items-center justify-between gap-2">
              <span className="min-w-0 truncate">
                <span className="font-medium">{i.name}</span>
                <span className="ml-2 text-muted-foreground">{i.sku_or_variant}</span>
              </span>
              <span className="flex shrink-0 items-center gap-2">
                <span className="font-medium">{i.stock}</span>
                <span className={`rounded px-1.5 py-0.5 text-xs ${(LEVEL[i.level] || LEVEL.low).cls}`}>{(LEVEL[i.level] || LEVEL.low).label}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </BlockCard>
  );
}
